import styled, { css, keyframes } from 'styled-components';
import { Loader2 } from 'lucide-react';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 90vh;

  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  justify-content: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const Spinner = styled(Loader2)`
  animation: ${spin} 1s linear infinite;
`;

export const WrapperInfo = styled.section`
  width: 50%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  ${({ theme }) => css`
    color: ${theme.colors.primary};
  `}

  > p {
    margin-top: 2rem;
  }
`;
